import { Typography, styled } from "@mui/material";
import { theme } from "../../../config";

export const StepLabel = styled(Typography)({
  color: theme.pallete.text.primary,
  fontWeight: 500,
  padding: "16px 0px",
});
